import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getOverlays } from "./action";

export const overlaysEnityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = overlaysEnityAdapter.getInitialState({
  count: 0,
});

export const overlaySlice = createSlice({
  name: "overlays",
  initialState: initialState,
  reducers: {
    showUploadOverlayModal: (state, action) => {
      state.modals.selectUploadBumperModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOverlays.fulfilled, (state, action) => {
      if (action.payload.success) {
        // console.log({payload : action.payload});
        overlaysEnityAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

export const { showUploadBumperModal } = overlaySlice.actions;

export default overlaySlice.reducer;
